'use client';
import { useCreateListing } from '../_context';
import { BProcess } from '@c/process/BaseProcess';

export const CreateListingProcess = () => {
  const { steps, currentStep } = useCreateListing();

  return (
    <div className="min-h-screen overflow-y-auto">
      <BProcess
        noStepper
        steps={steps}
        currentStep={currentStep}
        overflowStyle="visible"
      />
    </div>
  );
};
